import {
  menu_item_checkbox_style_default
} from "./chunk.7OL4GPLO.js";
import {
  focusVisibleSelector
} from "./chunk.ZLFKGBZ6.js";
import {
  labelSmall
} from "./chunk.GAOIIZQS.js";
import {
  r
} from "./chunk.4JTBA2KG.js";

// src/components/menu-item/menu-category.styles.ts
var menu_category_styles_default = r` ${menu_item_checkbox_style_default} .menu-item { color: var(--sl-color-gray-700); text-transform: uppercase; ${labelSmall} font-weight: var(--sl-font-weight-semibold); } .menu-item__category-count { margin-left: var(--sl-spacing-2x-small); } .menu-item .menu-item__check { margin-left: var(--sl-spacing-2x-small); } .menu-item.menu-item--indeterminate .menu-item__check { background: var(--sl-color-primary-600); border-color: var(--sl-color-primary-600); color: var(--sl-color-neutral-0); } .menu-item.menu-item--indeterminate .menu-item__check fadv-icon::part(base) { display: flex; } .menu-item:not(.menu-item--disabled):hover, .menu-item:not(.menu-item--disabled).menu-item--checked, :host(${focusVisibleSelector}:not(.sl-focus-invisible):not([aria-disabled='true'])) .menu-item { background: transparent; } `;

export {
  menu_category_styles_default
};
